import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import styles from '../../../styles';
import { Button, TextLink } from './';

const StyledContainer = styled.div`
  display: inline-flex;
  flex-direction: column;
  flex-grow: 0;
  flex-shrink: 0;
  align-items: flex-start;

  font-size: 1.25rem;
  ${styles.media.tablet`
    font-size: 1.75rem;
  `} ${styles.media.phone`
    font-size: 1.25rem;
  `} line-height: 1.6em;
  margin-bottom: 1.6em;
`;

const ContentLinkList = props => {
  const { links } = props;
  return (
    <StyledContainer>
      {links.map(
        (link, index) =>
          link.display_type === 'link' ? (
            <TextLink key={index} to={link.link.url}>
              {link.link.title}
            </TextLink>
          ) : (
            <Button key={index} to={link.link.url}>
              {link.link.title}
            </Button>
          )
      )}
    </StyledContainer>
  );
};

ContentLinkList.propTypes = {
  links: PropTypes.array.isRequired,
};

export default ContentLinkList;



// WEBPACK FOOTER //
// ./src/modules/pages/components/ContentLinkList.js